import React, {useEffect} from "react";
import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {IndexPage} from "~/apps/packages/warehouse-closure/components/IndexPage";
import {CreatePage} from "~/apps/packages/warehouse-closure/components/CreatePage";
import {DetailPage} from "~/apps/packages/warehouse-closure/components/DetailPage";
import {Redirect, Route, Switch} from "react-router-dom";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {useApolloClient} from "@apollo/client";
import {ServiceInterview} from "~/customers-experience/ServiceInterview";


export const APP_NAME = "warehouse-closure";
export const APP_VERSION = "1.0.0";

export const WarehouseClosureApp = () => {
    const client = useApolloClient();

    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "terminalReleases"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "terminalRelease"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "terminalReleaseCargos"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "terminalReleaseContracts"});
    }, [])

    return (
        <AccessRequired title="Закрытие склада">
            <BrowserRouter basename="/apps/warehouse-closure">
                <ServiceInterview serviceID={APP_NAME} serviceVersion={APP_VERSION}>
                    <Switch>
                        <Route path="/new">
                            <CreatePage/>
                        </Route>
                        <Route path="/:id" exact={true}>
                            <DetailPage/>
                        </Route>
                        <Route path="/" exact={true}>
                            <IndexPage/>
                        </Route>
                        <Route path="*">
                            <Redirect to="/"/>
                        </Route>
                    </Switch>
                </ServiceInterview>
            </BrowserRouter>
        </AccessRequired>
    )
}


export default WarehouseClosureApp;